export default {
  toastUpdateListingsErrorContent: {
    id: 'buyback_quotes_update_listings_toast_error_content',
    defaultMessage:
      "Several listings couldn't be updated. Go through your listings to see which ones failed.",
  },
}
